import * as Cart from '@Queries/Cart';
import generateProductHash from '@Utils/generateProductHash';

import type { ProductHashParams } from '@Utils/generateProductHash';

/**
 * Товар или комплект товаров уже в корзине?
 * @args  — продукт или продукты с информацией о товаре
 */

function useHasInCart(...args: ProductHashParams[]) {
  const shortCard = Cart.useCartShortInfo();

  if (!args.length) return false;

  const hashs = [];

  args.forEach((arg) => {
    hashs.push(generateProductHash(arg));
  });

  if (!shortCard.data?.positions) return false;

  return hashs.every((hash) => shortCard.data.positions.includes(hash));
}

export default useHasInCart;
